// extracted by mini-css-extract-plugin
export default {"placeholder":"Placeholder_placeholder__DQujR","placeholder-dark":"Placeholder_placeholder-dark__Hu0rL"};